module.exports = __webpack_public_path__ + "img/el-shop-yc.svg";